export const StepsEnum = {
  PersonalDetails: 1,
  EqualOpportunities: 2,
  EducationHistory: 3,
  MoreAboutYou: 4,
  Declaration: 5,
};

export const steps = [
  {
    step: StepsEnum.PersonalDetails,
    name: "Personal Details",
  },
  {
    step: StepsEnum.EqualOpportunities,
    name: "Equal Opportunities",
  },
  {
    step: StepsEnum.EducationHistory,
    name: "Education History",
  },
  {
    step: StepsEnum.MoreAboutYou,
    name: "More About You",
  },
  {
    step: StepsEnum.Declaration,
    name: "Declaration",
  },
];

export const getMaxPossibleStep = (data) => {
  if (data?.ApplicationUserDefined12) return StepsEnum.Declaration;
  if (data?.StillAtLastSchool) return StepsEnum.MoreAboutYou;
  if (data?.CriminalConvictionID) return StepsEnum.EducationHistory;
  if (data?.FirstForename) return StepsEnum.EqualOpportunities;

  return StepsEnum.PersonalDetails;
};
